module.exports = __webpack_public_path__ + "assets/media/s36.21b62af2.mp3";